export const makeLocalBusinessJsonLd = (name, description = '', phone = '') =>
  `"@type": "LocalBusiness",
  "name": "HelloTech ${name}",
  "description": "${description}",
  "openingHours": "24 hours",
  "currenciesAccepted": "USD",
  "paymentAccepted": "Credit Card",
  "image": "https://www.hellotech.com/HT-sharing-logo.png",
  "telephone": "${phone}"`;
